
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
    Authorization: sessionStorage.getItem('Authorization') ? JSON.parse(sessionStorage.getItem('Authorization')) : null,
    login: false,
    productId: '',
    // 物流产品信息
    productInfo: {},
    // 是否大客户
    isBigCustomer: false,
    baseUrl: '',
    lang: localStorage.getItem('lang') || 'zh',
    topType: false,
    version: localStorage.getItem('version'),
    // 缓存物流产品
    productType: "",
    // 物流产品loading
    productLoading: false,
    // 货值统计
    goodsValueCount: {
        // 箱数
        boxNum: 0,
        // 货值
        proValue: 0
    }
}

const getters = {
    version: state => state.version,
    markNoList: state => state.Authorization.markNoList,
    markNo: state => state.Authorization.markno
}


const mutations = {
    addUserdata(state, data) {
        state.Authorization = data
    },
    changeLogin(state, data) {
        state.login = data
    },
    setProduct(state, data) {
        state.productId = data
    },
    setBaseUrl(state, data) {
        state.baseUrl = data
    },
    setLang(state, data) {
        state.lang = data
    },
    setTopType(state, data) {
        state.topType = data
    },
    setVersion(state, data) {
        state.version = data
    },
    setProductInfo(state, data) {
        state.productInfo = data
    },
    // 设置大客户信息
    setIsBigCustomer(state, data) {
        state.isBigCustomer = data
    },
    // 设置首页tab栏信息
    setProductType(state, data) {
        state.productType = data
    },
    // 设置内容loading
    setProductLoading(state, data) {
        state.productLoading = data
    },
    // 设置货值箱数
    setGoodsCount(state, data) {
        state.goodsValueCount.boxNum = data.boxNum
    },
    // 设置货值
    setGoodsValue(state, data) {
        state.goodsValueCount.proValue = data.proValue
    }
}
export default new Vuex.Store({
    state,
    getters,
    mutations
});


// WEBPACK FOOTER //
// ./src/store/index.js